var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgStreaming = function SvgStreaming(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 85,
    height: 84,
    viewBox: "0 0 85 84",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M47.1372 21.498C36.2416 22.341 26.2839 23.2821 12.7354 24.8822C10.0775 25.1961 8.08565 27.4694 8.12861 30.1454C8.34538 43.6476 8.87057 52.6693 10.8833 65.5526C11.2817 68.1029 13.5072 69.9585 16.0881 69.9153C36.7974 69.088 50.0197 67.9628 70.3769 65.0496C72.9024 64.633 74.7526 62.4383 74.7148 59.8789C74.5813 50.824 74.2224 45.8218 73.1832 38.1254",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8506 65.8691C11.1102 68.7634 13.6148 71.0112 16.1955 70.9717C37.0471 71.5472 50.2508 70.4057 70.4725 66.1071C72.9972 65.687 74.7899 62.7472 74.7477 60.1386",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M47.8529 44.0433C48.4482 44.3193 48.5215 45.1363 47.9848 45.5138C45.0416 47.9883 43.2837 49.1558 40.0714 51.0806C39.5347 51.4581 38.7906 51.1131 38.732 50.4595C38.1258 46.6973 37.8565 42.3882 37.7291 40.967C37.6492 40.0754 38.306 39.7603 38.9014 40.0363C42.545 41.4282 44.4922 42.3205 47.8529 44.0433Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M48.8516 43.7914C49.5756 44.1271 49.6647 45.1206 49.012 45.5798C45.4326 48.5892 43.2946 50.0091 39.3879 52.35C38.7352 52.8091 37.8302 52.3895 37.7589 51.5947C37.0217 47.0192 36.6942 41.7785 36.5392 40.05C36.442 38.9657 37.2409 38.5825 37.9649 38.9182C42.3962 40.6109 44.7643 41.6961 48.8516 43.7914Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M47.1592 44.2204C47.6649 44.4549 47.7272 45.149 47.2712 45.4697C44.7707 47.572 43.2772 48.5639 40.5481 50.1991C40.0921 50.5199 39.4599 50.2268 39.4101 49.6715C38.8952 46.4752 38.6664 42.8142 38.5581 41.6068C38.4902 40.8493 39.0483 40.5816 39.554 40.8161C42.6496 41.9986 44.3039 42.7567 47.1592 44.2204Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M45.2661 44.148C45.9645 44.4718 46.0504 45.4302 45.4208 45.8731L41.2763 48.7886C40.6467 49.2315 39.7737 48.8268 39.7049 48.06L39.2523 43.0131C39.1835 42.2463 39.9706 41.6927 40.669 42.0165L45.2661 44.148Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M43.3974 44.3152C44.0958 44.639 44.1817 45.5974 43.5521 46.0403L42.0645 47.0868C41.4349 47.5297 40.5619 47.1249 40.4931 46.3582L40.3307 44.5467C40.2619 43.7799 41.0489 43.2263 41.7473 43.5501L43.3974 44.3152Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M43.7236 45.1563L40.6581 45.4312",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M63.1848 32.394C62.1255 30.6537 57.0559 28.9891 55.1643 30.8807C54.7104 31.3347 54.4834 31.7887 54.332 32.2427",
    stroke: "black",
    strokeWidth: 1.5,
    strokeMiterlimit: 1.2063,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M54.3326 32.2423C53.5759 35.1932 58.8724 37.9928 62.9583 34.8906C63.488 34.5122 63.3366 32.6206 63.1853 28.5348C63.1096 26.1135 63.1853 24.4489 63.1853 22.0276L63.034 17.7904L63.1096 14.2342C63.1096 13.6289 78.2425 8.40805 79.8315 7.80273C80.2854 8.33238 80.4368 15.3692 80.3611 22.5573C80.2854 27.6268 80.0585 32.6206 79.3775 33.1503C74.308 36.7065 67.8765 31.41 72.492 28.6104C74.081 27.6268 78.3182 28.6861 79.6801 30.6534",
    stroke: "black",
    strokeWidth: 1.5,
    strokeMiterlimit: 1.2063,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M63.5635 22.0288C65.5307 21.6505 68.2547 20.5156 71.7352 19.5319C72.1892 19.3806 78.0154 17.262 79.8313 16.4297",
    stroke: "black",
    strokeWidth: 1.5,
    strokeMiterlimit: 1.2063,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M51.5818 11.6844C47.0419 11.3817 43.7884 10.1711 43.7884 10.1711C43.6371 8.43084 43.7884 7.67419 43.864 5.93392C43.9397 5.3286 44.1667 3.36133 44.1667 3.36133C46.6636 3.89098 49.0092 4.64762 50.9765 5.17727C51.4305 5.3286 51.7331 5.40426 52.3385 5.78259C53.0194 6.23657 52.7168 6.53923 52.3385 11.0791C52.1115 13.9543 51.8845 17.3592 51.5818 20.9155C51.4305 22.2774 51.4305 22.7314 52.3385 23.3367C56.3487 25.8336 59.9049 24.2447 59.7536 21.8234C59.5266 18.1915 52.7168 18.9482 51.7331 20.6885",
    stroke: "black",
    strokeWidth: 1.5,
    strokeMiterlimit: 1.2063,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M63.3359 22.3306C66.3625 21.5739 74.9126 18.7743 80.0578 16.5801",
    stroke: "black",
    strokeWidth: 1.5,
    strokeMiterlimit: 1.2063,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M43.8633 10.0957C45.6036 11.0793 49.4624 11.6847 52.1107 11.7603",
    stroke: "black",
    strokeWidth: 1.5,
    strokeMiterlimit: 1.2063,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M54.7861 34.3613C56.2238 36.6313 60.8393 37.1609 62.8822 35.118",
    stroke: "black",
    strokeWidth: 1.5,
    strokeMiterlimit: 1.2063,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M70.9023 31.4863C70.9023 32.3943 71.9616 33.3023 72.7183 33.6806C74.9882 34.9669 78.2418 34.6642 79.4524 32.8483",
    stroke: "black",
    strokeWidth: 1.5,
    strokeMiterlimit: 1.2063,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M51.8838 23.0345C53.1701 24.0938 55.1374 25.0774 57.1803 24.6991C58.5422 24.4721 59.6772 23.4128 59.6772 22.3535",
    stroke: "black",
    strokeWidth: 1.5,
    strokeMiterlimit: 1.2063,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgStreaming);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "streaming.cfe0873573fd28f759d26a0a1ecd9bf2.svg";